import { createApp } from 'vue'
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import App from './App.vue'
// import Antd from './configAntD'
import LegoBricks from '@smilekite/lego-bricks'
import router from './routes/index'
import store from './store/index'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@smilekite/lego-bricks/dist/bundle.css'
import 'cropperjs/dist/cropper.css'
import './styles/index'
import { RespData } from './store/respTypes'
export type ICustomAxiosConfig = AxiosRequestConfig & {
  opName?: string
}

const app = createApp(App)
axios.defaults.baseURL = `/api`
axios.interceptors.request.use(config => {
  const newConfig = config as ICustomAxiosConfig
  store.commit('setError', { status: false, message: '' })
  store.commit('startLoading', { opName: newConfig.opName })
  return config
})
axios.interceptors.response.use(
  (resp: AxiosResponse<RespData>) => {
    const { config, data } = resp
    const newConfig = config as ICustomAxiosConfig
    store.commit('finishLoading', { opName: newConfig.opName })
    const { errno, message } = data
    if (errno && errno !== 0) {
      store.commit('setError', { status: true, message })
      return Promise.reject(data)
    }
    return resp
  },
  (e: AxiosError) => {
    const newConfig = e.config as ICustomAxiosConfig
    store.commit('setError', { status: true, message: '服务器错误' })
    store.commit('finishLoading', { opName: newConfig.opName })
    return Promise.reject(e)
  }
)
app.use(Antd).use(LegoBricks).use(router).use(store)
app.mount('#app')
